import { render } from "./ArtistBio.vue?vue&type=template&id=75e4b1af"
import script from "./ArtistBio.vue?vue&type=script&lang=js"
export * from "./ArtistBio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__